import React from 'react';
import { Link } from 'react-router-dom';

import Button from 'components/Button';

const Footer = () => (
  <footer className="footer has-shadow otoschool-background">
    <nav className="level">
      <div className="level-left">
        <div className="level-item">
          <Button className="is-text px-0">
            Reporter un problème
          </Button>
        </div>
        <div className="level-item">
          <Link to="#" className="text-link">
            Conditions d'utilisations
          </Link>
        </div>
        <div className="level-item">
          <Link to="#" className="text-link">
            Politique de confidentialité
          </Link>
        </div>
      </div>
      <div className="level-right">
        <div className="level-item">
          Otoschool - Eleves &copy; 2021
        </div>
      </div>
    </nav>
  </footer>
)

export default Footer
